export const getPostingStatus = (message) => {
    const safeMessage = message || {};

    if (safeMessage.posting_error) {
        return 'failed';
    }

    if (safeMessage.posted_trans_id || safeMessage.auto_posted) {
        return 'posted';
    }

    if (safeMessage.eval) {
        return safeMessage.used ? 'used' : 'pending';
    }

    return 'pending';
};
